import { initializeApp, getApps } from "firebase/app"
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth"

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  appId: process.env.VUE_APP_FIREBASE_APPID
}

let auth = null
let verifier = null
let confirmationResult = null

export function initFirebase() {
  if (!auth) {
    const app =
      getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig)
    auth = getAuth(app)
  }
  return auth
}

// 发送短信验证码（invisible reCAPTCHA 挂在页面隐藏容器上）
export async function sendSmsCode(phoneE164, containerId = "recaptcha-container") {
  initFirebase()
  if (verifier) {
    try {
      verifier.clear()
    } catch (e) {}
    verifier = null
  }
  verifier = new RecaptchaVerifier(containerId, { size: "invisible" }, auth)
  confirmationResult = await signInWithPhoneNumber(auth, phoneE164, verifier)
}

// 校验用户输入的短信验证码，返回后端登录所需的 Firebase 用户信息
export async function verifySmsCode(code) {
  if (!confirmationResult) {
    throw new Error("Please request the verification code first")
  }
  const cred = await confirmationResult.confirm(code)
  const user = cred.user
  const idToken = await user.getIdToken()
  return {
    idToken,
    uid: user.uid,
    phoneNumber: user.phoneNumber,
    displayName: user.displayName,
    email: user.email,
    photoUrl: user.photoURL
  }
}
